// extracted by mini-css-extract-plugin
export default {"icon":"ClientDrawer_icon__28PP7"};